import React, { ReactNode } from 'react';
import styles from './style.module.scss';
import { listingPageModalIds } from 'constants/test-constants';

interface Props {
  isPrivate: boolean;
  contentIsRaw?: boolean;
  children: ReactNode;
}

export default function DetailsTable({ isPrivate, contentIsRaw, children }: Props) {
  return (
    <div className={`${styles.component} ${isPrivate && styles['is-private']}`} data-testid={listingPageModalIds.detailsTable}>
      {contentIsRaw ? children :
        <section>
          {children}
        </section>
      }
    </div>
  );
}
